import { AUTH_ROUTES } from "./authRoutes";
import React, { useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./SignIn.css";
import ForgotBg from "../assets/images/forgot-bg.svg";
import ForgotMobile from "../assets/images/forgot-mobile.svg";
import { useMediaQuery } from "react-responsive";
import { BackSVG } from "../components/SvgIcons";
import { requestForgotPasswordOtp } from "../services/authService";

function ForgotPwd() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [submitError, setSubmitError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedEmail = email.trim().toLowerCase();
    if (!trimmedEmail) {
      setEmailError("Email is required.");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(trimmedEmail)) {
      setEmailError("Enter a valid email address.");
      return;
    }

    setEmailError("");
    setSubmitError("");
    setIsSubmitting(true);

    try {
      const { payload, meta } = await requestForgotPasswordOtp({ email: trimmedEmail });
      const userId = payload?.user_id;

      if (!userId) {
        throw new Error(meta?.message || "Unable to send verification code.");
      }

      navigate(AUTH_ROUTES.checkEmail, {
        replace: true,
        state: {
          userId,
          email: trimmedEmail,
        },
      });
    } catch (error) {
      setSubmitError(error.message || "Unable to send verification code right now.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container-fluid signin-container auth-background">
      <div className="row auth-page-row">
        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-white left-section p-0 verifiy-LeftSection">
          <div className="verificationBg">
            <img src={ForgotBg} alt="" className="img-fluid mb-4" />
          </div>
        </div>

        <div className="col-md-6 d-flex justify-content-center align-items-center right-section verification-box mobile-display">
          <div className="backIcon ps-4 pe-4 d-block d-md-none" onClick={() => navigate(AUTH_ROUTES.signIn)}>
            <BackSVG />
          </div>
          <div className="signin-mobile ps-4 pe-4 verify-mobile d-block d-md-none mx-auto text-center">
            <img src={ForgotMobile} alt="" className="mx-auto" />
          </div>

          <div className="signin-box auth-form-card p-4 p-md-5 rounded">
            <h3 className="fw-semibold text-center mb-2">Forgot Password</h3>
            <p className="text-center fw-medium mobile-paragraph auth-form-intro">
              Enter your email to receive an OTP to reset your password.
            </p>

            {submitError ? (
              <Alert className="mb-3" variant="danger">
                {submitError}
              </Alert>
            ) : null}

            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="forgotEmail">
                <Form.Label>Email</Form.Label>
                <div className="auth-form-field">
                  <span className="auth-field-icon" aria-hidden="true"><i className="bi bi-envelope" /></span>
                  <Form.Control
                    autoComplete="email"
                    type="email"
                    placeholder={isMobile ? "Email" : "Enter your Email"}
                    value={email}
                    isInvalid={Boolean(emailError)}
                    onChange={(event) => {
                      setEmail(event.target.value);
                      setEmailError("");
                      setSubmitError("");
                    }}
                  />
                </div>
                <Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
              </Form.Group>

              <Button className="w-100 py-2 fw-semibold signin-btn mt-4" disabled={isSubmitting} type="submit">
                {isSubmitting ? "Sending..." : "Send Code"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPwd;
